import { jsonp, ajax } from '@ifeng/ui_base';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;

/* eslint-enable no-undef */

if (/\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

const createJsonpCallbackName = (str, num) => {
    const md5 = require('md5');

    num = num ? num : 0;
    const jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    if (window[jsonpCallbackName]) {
        num++;
        createJsonpCallbackName(str, num);
    } else {
        return jsonpCallbackName;
    }
};

/* 公共 */

// 获取文章评论数
const getCommentCount = async url => {
    return await jsonp('//comment.ifeng.com/get.php', {
        data: {
            job: 4,
            format: 'js',
            callback: 'getAllComment1',
            docurl: url.join('|'),
        },
        jsonCallback: 'getAllComment1',
        cache: false,
    });
};

// 点击更多，获取信息流
// const getColumnInfo = async (id, time, size, columnId) => {
//     return await ajax(`/c/api/getColumnInfo/${id}/${time}/${size}/${columnId}`);
// };

// 点击更多，获取信息流
const getColumnInfo2 = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getColumnInfo2/${id}/${time}/${size}/${columnId}/getColumnInfoCallback`, {
        jsonpCallback: 'getColumnInfoCallback',
    });
};

// 点击更多，获取科技频道信息流
const getTechInfo = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getTechInfo/${id}/${time}/${size}/${columnId}/getTechInfoCallback`, {
        jsonpCallback: 'getTechInfoCallback',
    });
};

// 获取公益频道信息流
const getGongyiData = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getGongyiData/${id}/${time}/${size}/${columnId}/getGongyiDataCallback`, {
        jsonpCallback: 'getGongyiDataCallback',
    });
};

/**
 * 获取页面动态碎片数据
 * @param {Array} recommendDataIds 推荐位数据IDs
 * @param {String} searchPath searchPath
 * @param {Number} page 当前页数
 * @param {Number} pageSize 每页请求条数
 * @returns {Object} {dynamicList, pageInfo}
 */
const getDynamicData = async ({ recommendDataIds = [], searchPath = 0, page = 1, pageSize = 9 }) => {
    const recommendIds = recommendDataIds.join(',');

    const data = await jsonp(
        `${apiBaseUrl}/getDynamicData/${searchPath}/${recommendIds}/${page}/${pageSize}/getDynamicData`,
        {
            jsonpCallback: 'getDynamicData',
        },
    );

    return data.data;
};

// 点击更多，获取信息流
const getYoungInfo = async (id, time, size, columnId) => {
    return await jsonp(`${apiBaseUrl}/getYoungInfo/${id}/${time}/${size}/${columnId}/getYoungInfoCallback`, {
        jsonpCallback: 'getYoungInfoCallback',
    });
};

// 青年频道 获取文章推荐数

const getVoteNum = async url => {
    // const { schemaCheck } = await import('./validate');

    let apiUrl = '//survey.news.ifeng.com/api/getaccumulatorweight?';

    // 接口拼接
    if (url.length > 0) {
        url.forEach(item => {
            apiUrl += `key[]=${item}ding&`;
        });
    }

    let data = await jsonp(apiUrl, {
        data: {
            format: 'js',
            serviceid: 2,
        },
        jsonCallback: 'getaccumulator',
        cache: false,
    });
    // const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${vid}&callback=getaccumulator`;

    // data = schemaCheck(data.data, 'voteNumSchema', requestUrl);
    data = data.data;

    return data ? data : null;
};

export { getCommentCount, getColumnInfo2, getDynamicData, getTechInfo, getGongyiData, getYoungInfo, getVoteNum };
